import _get from 'lodash/get';

export default function wasThisAnswerRemoved(answer) {
  const value = _get(answer, 'details.value', '');
  // if answer has some value it means it was already answered
  // if answer has ID it means it is persisted, we want to find not persisted - already removed
  return value && toString(value).length && !answer.id;
}
